import { render, staticRenderFns } from "./LicitacaoAtualizacaoEnviarMaisBrasil.vue?vue&type=template&id=4fd4f1de"
import script from "./LicitacaoAtualizacaoEnviarMaisBrasil.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoEnviarMaisBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports